import { checkHttpStatus, parseJSON, expiredToken } from '@utils/response';
import { Token, UserCode, Company } from '@utils/users';
import { errorResponse, okResponse, ok } from '@utils/response';
import { encryption } from '@utils/encryption';
import { GetLanguage } from '@utils/language';

export function getInfoPunchAndReport(punchId, reportId) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.punchIdCrypt = encryption(punchId);
    params.reportIdCrypt = encryption(reportId);
    params.companyCrypt = encryption(Company());
    params.language = GetLanguage(),
    params.token = Token();

    return fetch('reportDaily/getInfoPunchAndReport', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return okResponse({ result: JSON.parse(result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function getAllActivesEquipments() {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.token = Token();

    return fetch('reportDaily/getAllActivesEquipments', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return JSON.parse(result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function getAllActivesIncidentTypes() {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.token = Token();

    return fetch('reportDaily/getAllActivesIncidentTypes', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return JSON.parse(result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function saveDailyReport(model) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.reportIdCrypt = encryption(model.reportId);
    params.punchIdCrypt = encryption(model.punchId);
    params.reliefAgent = model.reliefAgent;
    params.descriptionTask = model.descriptionTask;
    params.equipments = model.equipments;
    params.equipmentValues = model.equipmentValues;
    params.typeIncidents = model.typeIncidents;
    params.incidents = model.incidents;
    params.token = Token();

    return fetch('reportDaily/saveDailyReport', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return ok();
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}

export function getListReport(punchId) {
    const params = {};
    params.userCodeCrypt = encryption(UserCode());
    params.punchIdCrypt = encryption(punchId);
    params.token = Token();

    return fetch('reportDaily/getListReport', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                const result = response.result;

                if (response.result.codeReturn !== undefined) {
                    return result;
                }

                return okResponse({ result: JSON.parse(result) });
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse(error);
        })
}